module.exports = __webpack_public_path__ + "img/t2-name.946418b1.png";